module.exports = function eventTracker(rootClassName, trackerAttributeName, handler) {
  const root = document.getElementsByClassName(rootClassName)[0];
  root.addEventListener('click', event => {
    const trackerElement = event.target.closest(`[${trackerAttributeName}]`);
    if (trackerElement) {
      const dataString = decodeURIComponent(trackerElement.getAttribute(`${trackerAttributeName}`));
      let trackerData = {};
      try {
        trackerData = JSON.parse(dataString);
      } catch (e) {
        trackerData = dataString
      }
      handler(trackerData);
    }
  });
};
